const VALUE_DELIMITERS = {
    '(': ')',
    '\'': '\'',
    '"': '"',
    '{': '}'
};
const BASE_UNIT_REGEX = /^([+-]?(?:\d+(?:\.?\d+)?|\.\d+))x$/m // 1x, 1.1x, -1x, -.1x
;
const TRANSITION_SIGN = '~';
const ANIMATION_SIGN = '@';
const SELECTOR_SIGNS = [
    ':',
    '_',
    '>',
    '+',
    '~'
];
const SELECTOR_COMBINATORS = [
    '_',
    '>',
    '+',
    '~'
];
const QUERY_COMPARISON_OPERATORS = [
    '>',
    '<',
    '='
];
const QUERY_LOGICAL_OPERATORS = [
    '&'
];
const SEPARATOR_SIGNS = [
    ',',
    '|'
];
const DELIMITER_SIGN = '|';
const SEPARATOR_SIGN = ',';
const AT_SIGN = '@';
const VALUE_UNITS = [
    '%',
    'cm',
    'mm',
    'q',
    'in',
    'pt',
    'pc',
    'px',
    'em',
    'rem',
    'ex',
    'rex',
    'cap',
    'rcap',
    'ch',
    'rch',
    'ic',
    'ric',
    'lh',
    'rlh',
    'vw',
    'svw',
    'lvw',
    'dvw',
    'vh',
    'svh',
    'lvh',
    'dvh',
    'vi',
    'svi',
    'lvi',
    'dvi',
    'vb',
    'svb',
    'lvb',
    'dvb',
    'vmin',
    'svmin',
    'lvmin',
    'dvmin',
    'vmax',
    'svmax',
    'lvmax',
    'dvmax',
    'cqw',
    'cqh',
    'cqi',
    'cqb',
    'cqmin',
    'cqmax',
    'deg',
    'grad',
    'rad',
    'turn',
    's',
    'ms',
    'hz',
    'khz',
    'dpi',
    'dpcm',
    'dppx',
    'x',
    'fr',
    'db',
    'st'
];
const UNIT_REGEX = /^([+-.]?\d+(?:\.?\d+)?)(%|cm|mm|q|in|pt|pc|px|em|rem|ex|rex|cap|rcap|ch|rch|ic|ric|lh|rlh|vw|svw|lvw|dvw|vh|svh|lvh|dvh|vi|svi|lvi|dvi|vb|svb|lvb|dvb|vmin|svmin|lvmin|dvmin|vmax|svmax|lvmax|dvmax|cqw|cqh|cqi|cqb|cqmin|cqmax|deg|grad|rad|turn|s|ms|hz|khz|dpi|dpcm|dppx|x|fr|db|st)?$/;
const IMAGE_VALUE_REGEX = /(?:url|linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient|conic-gradient)\(.*\)/;
const COLOR_VALUE_REGEX = /(?:#|(?:color|color-contrast|color-mix|hwb|lab|lch|oklab|oklch|rgb|rgba|hsl|hsla|light-dark)\(.*\)|(?:\$colors)(?![a-zA-Z0-9-]))/;
const NUMBER_VALUE_REGEX = /(?:[\d.]|(?:max|min|calc|clamp)\([^|]*\))/;
const OFFICIAL_URL = new URL('https://rc.css.master.co');
const CLASS_ATTRIBUTES = [
    'class',
    'className'
];
const CLASS_DECLARATIONS = [
    'components'
];
const CLASS_FUNCTIONS = [
    'clsx',
    'cva',
    'ctl',
    'cv',
    'class',
    'classnames',
    'classVariant',
    'styled(?:\\s+)?(?:\\.\\w+)?',
    'classList(?:\\s+)?\\.(?:add|remove|toggle|replace)'
];
const BORDER_STYLE_VALUES = [
    'none',
    'auto',
    'hidden',
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset'
];
const AT_COMPARISON_OPERATORS = [
    '>=',
    '<=',
    '>',
    '<',
    '='
];
const AT_LOGICAL_OPERATORS = {
    '&': 'and',
    '!': 'not',
    // native
    'not': 'not',
    'and': 'and',
    'or': 'or',
    'only': 'only',
    ',': 'or'
};
// the order is intentional and should not be changed
const AT_IDENTIFIERS = [
    'container',
    'starting-style',
    'supports',
    'media',
    'layer'
];
const COMPARISION_OPERATORS = [
    '>=',
    '<=',
    '>',
    '<',
    '='
];
const AT_COMPARABLE_FEATURES = [
    'width',
    'height',
    'resolution'
];
const __UNSORTED__ = '__UNSORTED__';

export { ANIMATION_SIGN, AT_COMPARABLE_FEATURES, AT_COMPARISON_OPERATORS, AT_IDENTIFIERS, AT_LOGICAL_OPERATORS, AT_SIGN, BASE_UNIT_REGEX, BORDER_STYLE_VALUES, CLASS_ATTRIBUTES, CLASS_DECLARATIONS, CLASS_FUNCTIONS, COLOR_VALUE_REGEX, COMPARISION_OPERATORS, DELIMITER_SIGN, IMAGE_VALUE_REGEX, NUMBER_VALUE_REGEX, OFFICIAL_URL, QUERY_COMPARISON_OPERATORS, QUERY_LOGICAL_OPERATORS, SELECTOR_COMBINATORS, SELECTOR_SIGNS, SEPARATOR_SIGN, SEPARATOR_SIGNS, TRANSITION_SIGN, UNIT_REGEX, VALUE_DELIMITERS, VALUE_UNITS, __UNSORTED__ };
